import(/* webpackMode: "eager" */ "/vercel/path0/packages/frontend/app/global-error.tsx");
